export enum MediaCenterEvent {
    RENDER_FILTERED_SLIDES = 'mediaCenter:render:filtered',
}
